// ============================================================================
// AUTH REPOSITORY
// ARQUIVO: src/services/AuthRepository.js
// RESPONSABILIDADE: Login, logout, subscription de estado de autenticação.
// Criado em: 17/05/2026 — split de LegalCore.jsx (Fase 2 auditoria arquitetural)
// ============================================================================

import {
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
} from "firebase/auth";
import { auth } from '../shared/api/firebase/config';
import { LAW_FIRM_INFO } from "../config/Config";

const ADMIN_EMAILS = [
  LAW_FIRM_INFO.contact.email,
  "rodrigo@rodrigodemeterco.adv.br",
  "admin@rda.adv.br",
  "robo@rda.adv.br",
];

export const checkIsAdmin = (user) => {
  if (!user || !user.email) return false;
  return ADMIN_EMAILS.includes(user.email) || user.email.endsWith("@rodrigodemeterco.adv.br");
};

export const loginUser = async (email, password) => {
  try {
    const timeoutPromise = new Promise((_, reject) => {
      setTimeout(() => reject(new Error("TIMEOUT_AUTH_HANG")), 10000);
    });
    const loginPromise = signInWithEmailAndPassword(auth, email, password);
    const result = await Promise.race([loginPromise, timeoutPromise]);
    return { success: true, user: result.user };
  } catch (error) {
    if (error.code === "auth/multi-factor-auth-required") {
      console.info("[RDA Auth] MFA requerido para", email);
      return { success: false, error: error };
    }
    if (error.message === "TIMEOUT_AUTH_HANG") {
      return { success: false, error: "Erro: O servidor demorou a responder. Possível bloqueio de cache." };
    }
    if (error.code === "auth/network-request-failed") {
      return { success: false, error: "Erro de Rede. Verifique sua conexão ou se a API Key permite localhost." };
    }
    if (
      error.code === "auth/invalid-credential" ||
      error.code === "auth/user-not-found" ||
      error.code === "auth/wrong-password"
    ) {
      return { success: false, error: "E-mail ou senha incorretos." };
    }
    if (error.code === "auth/too-many-requests") {
      return { success: false, error: "Muitas tentativas. A conta foi temporariamente bloqueada. Tente mais tarde." };
    }
    console.error("❌ [RDA Auth] Erro Detalhado:", error?.code, error?.message);
    return { success: false, error: error.message };
  }
};

export const logoutUser = async () => {
  try {
    await signOut(auth);
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const subscribeToAuth = (callback) => {
  return onAuthStateChanged(auth, (user) => {
    callback(user);
  });
};
